import React from 'react';

interface TooltipState {
  visible: boolean;
  content: string;
  x: number;
  y: number;
}

interface TooltipProps {
  tooltip: TooltipState;
}

function Tooltip({ tooltip }: TooltipProps) {
  if (!tooltip.visible) {
    return null;
  }

  return (
    <div
      className="pointer-events-none fixed z-[1000] max-w-md rounded-lg border border-gray-200 bg-white p-4 text-sm leading-relaxed text-gray-600 shadow-xl"
      style={{ 
        left: Math.max(8, Math.min(tooltip.x, window.innerWidth - 8 - 360)),
        top: Math.max(8, Math.min(tooltip.y, window.innerHeight - 8 - 160)),
      }}
    >
      {tooltip.content}
    </div>
  );
}

export default Tooltip;
